import React, { useState, useEffect } from 'react';
import { getAppSettings, updateAppSetting } from '../../services/api';
import { FiSettings, FiSave } from 'react-icons/fi';

const CATEGORIE_LABELS: Record<string, string> = {
    general: 'General',
    security: 'Securite',
    notifications: 'Notifications',
    audit: 'Audit',
};

const AppSettings: React.FC = () => {
    const [settings, setSettings] = useState<any>({});
    const [modified, setModified] = useState<Set<string>>(new Set());
    const [saving, setSaving] = useState<string | null>(null);

    useEffect(() => {
        getAppSettings().then(res => setSettings(res.data));
    }, []);

    const handleChange = (cle: string, valeur: string) => {
        const newSettings = { ...settings };
        for (const cat of Object.keys(newSettings)) {
            newSettings[cat] = newSettings[cat].map((s: any) => s.cle === cle ? { ...s, valeur } : s);
        }
        setSettings(newSettings);
        setModified(new Set([...Array.from(modified), cle]));
    };

    const handleSave = async (cle: string) => {
        setSaving(cle);
        try {
            const setting = Object.values(settings).flat().find((s: any) => s.cle === cle) as any;
            await updateAppSetting(cle, { valeur: setting.valeur });
            setModified(prev => { const n = new Set(prev); n.delete(cle); return n; });
        } catch (err: any) { alert(err.response?.data?.error || 'Erreur'); }
        finally { setSaving(null); }
    };

    const renderInput = (s: any) => {
        if (s.type === 'boolean') {
            return (
                <select value={s.valeur} onChange={e => handleChange(s.cle, e.target.value)}>
                    <option value="true">Oui</option>
                    <option value="false">Non</option>
                </select>
            );
        }
        if (s.type === 'number') {
            return <input type="number" value={s.valeur} onChange={e => handleChange(s.cle, e.target.value)} />;
        }
        return <input value={s.valeur || ''} onChange={e => handleChange(s.cle, e.target.value)} />;
    };

    return (
        <div className="page-settings">
            <div className="page-header"><h2><FiSettings /> Parametres</h2></div>

            {Object.entries(settings).map(([categorie, items]: [string, any]) => (
                <div key={categorie} className="chart-card" style={{ marginBottom: 16 }}>
                    <h3>{CATEGORIE_LABELS[categorie] || categorie}</h3>
                    {items.map((s: any) => (
                        <div key={s.cle} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                            <div style={{ flex: 1 }}>
                                <div className="form-group" style={{ marginBottom: 0 }}>
                                    <label>{s.description || s.cle}</label>
                                    {renderInput(s)}
                                </div>
                            </div>
                            {modified.has(s.cle) && (
                                <button className="btn btn-sm btn-primary" onClick={() => handleSave(s.cle)} disabled={saving === s.cle}>
                                    <FiSave /> {saving === s.cle ? '...' : 'Sauver'}
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default AppSettings;
